// Check .env to view any global value.
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const request = (endpoint, options, success, failure) =>
  fetch(`${API_ENDPOINT}${endpoint}`, options)
    .then(response => 
        response.json()
            .then(data => {
                if(response.status >= 200 && response.status < 300)
                    success(data);
                else
                    throw data;
            })
            .catch(error => failure(error))
    )
    .catch(error => failure(error));

export const apiRequest = (endpoint, options = {}, success = result => {}, failure = error => {}) => {
  const newOptions = {
    method: 'GET',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  }
  return request(endpoint, newOptions, success, failure)
}
